import { unstable_HistoryRouter as Router } from 'react-router-dom';
import '@/assets/css/common.less';
import RouteRender from '@/routers/RouteRender';
import { createBrowserHistory } from 'history';
import 'lib-flexible';
import { render } from 'react-dom';
import { GlobalProvider } from 'rmox';
import { setWindowHeight } from './utils';
// import VConsole from 'vconsole';
// let vConsole = new VConsole();

const urlVal = new URL(window.location.href);
const channel = urlVal.searchParams.get('channel');
if (channel) {
  localStorage.setItem('channel', channel);
}

setWindowHeight();
window.onresize = () => {
  setWindowHeight();
};

render(
  <GlobalProvider>
    <Router history={createBrowserHistory()}>
      <RouteRender />
    </Router>
  </GlobalProvider>,
  document.getElementById('root'),
);
